module.exports = __webpack_public_path__ + "img/crud-app-nest-js_backend.4dc75451.png";